module.exports = __webpack_public_path__ + "6da204ee.png";